"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zListCustomersQuery = exports.zUpdateCustomerRequest = exports.zCreateCustomerRequest = exports.zCustomerPhoneInput = exports.zCustomerPhoneType = exports.CUSTOMER_PHONE_TYPES = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
/**
 * The typed phone list the sample invoice proves is necessary: it prints
 * "Home 214-293-2809", not just a bare number. Kept as-displayed on the
 * server too (see apps/api/src/db/schema/customers.ts) — never normalized
 * to E.164, which would print "+12142932809" on an invoice instead.
 */
exports.CUSTOMER_PHONE_TYPES = ["home", "mobile", "work", "fax", "other"];
exports.zCustomerPhoneType = zod_1.z.enum(exports.CUSTOMER_PHONE_TYPES);
exports.zCustomerPhoneInput = zod_1.z.object({
    phoneType: exports.zCustomerPhoneType,
    phoneNumber: zod_1.z.string().trim().min(1),
    isPrimary: zod_1.z.boolean().default(false),
    sortOrder: zod_1.z.number().int().default(0),
});
function atMostOnePrimary(phones) {
    return !phones || phones.filter((p) => p.isPrimary).length <= 1;
}
const customerFields = {
    // Entered, not synthesized from first/last — the sample reads
    // "LAKHANI RAFIQ", surname first, exactly as the shop typed it.
    displayName: zod_1.z.string().trim().min(1),
    email: zod_1.z.string().trim().toLowerCase().email().nullable().optional(),
    taxExempt: zod_1.z.boolean().default(false),
    taxExemptCertificate: zod_1.z.string().trim().min(1).nullable().optional(),
    notes: zod_1.z.string().trim().min(1).nullable().optional(),
};
exports.zCreateCustomerRequest = zod_1.z
    .object({ ...customerFields, phones: zod_1.z.array(exports.zCustomerPhoneInput).default([]) })
    .refine((data) => atMostOnePrimary(data.phones), {
    message: "At most one phone may be marked primary.",
    path: ["phones"],
});
// Full-replace semantics for phones on update, same as create — there is no
// per-phone PATCH in the MVP, so the client always sends the complete list.
exports.zUpdateCustomerRequest = zod_1.z
    .object({ ...customerFields, phones: zod_1.z.array(exports.zCustomerPhoneInput) })
    .partial()
    .refine((data) => atMostOnePrimary(data.phones), {
    message: "At most one phone may be marked primary.",
    path: ["phones"],
});
exports.zListCustomersQuery = zod_1.z.object({
    // Matches display name (trigram), customer number (exact), or phone
    // digits (substring) — see CustomersService.list().
    search: zod_1.z.string().trim().min(1).optional(),
    includeInactive: query_params_js_1.zBooleanQueryParam.default(false),
    // Unset (the default) sorts by createdAt desc — recently added first, per
    // the owner's ask — same "unset keeps the service's own default" pattern
    // as work-orders.ts/invoices.ts's own sortBy.
    sortBy: zod_1.z.enum(["createdAt", "displayName"]).optional(),
    sortDirection: zod_1.z.enum(["asc", "desc"]).default("desc"),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=customers.js.map